


$(document).ready(function(){
  console.log('hfc');

  var target = document.querySelector("#wsg-cart");

// Create an observer instance
var observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    // Check if the mutation added any new nodes
    if (mutation.addedNodes.length > 0) {
      // Loop through the added nodes
      for (var i = 0; i < mutation.addedNodes.length; i++) {
        var node = mutation.addedNodes[i];
        // Check if the node is an element and if it has a class containing the number 945
        console.log(node.className);
        if (node.nodeType === Node.ELEMENT_NODE && node.className.indexOf("wsg-cart-product-42866322309282") !== -1) {
          // Add the custom class to the node
          node.classList.add("wsg-cart-product-fee-item");

          var input = node.querySelector(".wsg-cart__quantity-selector");
          var priceBlock = node.querySelector(".wsg-prices-block");
          // Get the value of the input
          var inputValue = parseInt(input.value);
          var dollars = inputValue / 100;
          var dollarAmount = "Fee amount: $" + dollars.toFixed(2);
          // Create a new span element
          var span = document.createElement("span");
          // Set the innerHTML of the span to be the input value
          span.innerHTML = dollarAmount;
          span.classList.add("custom-fee-amount");
          // Add the span element to the node
          priceBlock.appendChild(span);
        }
      }
    }
  });
});

// Configure the observer
const config = { attributes: true, childList: true, subtree: true };

// Start observing the target
if(target){
  observer.observe(target, config);
}

  function processFeeLineItem() {
    console.log('pfli');
    $('.wsg-cart-product').each(function(){
      console.log($(this));
      if ( $(this).hasClass('wsg-cart-product-42866322309282') ) {
        $(this).addClass('fee-product-line-item');
      }
    });
  }

});





function dontuse(){
  const targetNode = document.getElementById("target-element");

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      for (let i = 0; i < mutation.addedNodes.length; i++) {
        if (mutation.addedNodes[i].id === "customId") {
          console.log("element with id 'customId' added to target element!");
        }
      }
    });
  });

  const config = { childList: true };
  observer.observe(targetNode, config);
}